import DefaultLayout from 'views/layout/index';
import { PATH_FOR_DOCUMENT_INDEX } from 'util/constants';

const rootRoutes = [
    {
        id: "document",
        path: "/document/:subMenu",
        exact: false,
        component: DefaultLayout
    },{
        id: "redirect",
        redirect: true,
        path: "/",
        to: PATH_FOR_DOCUMENT_INDEX
    }
];

export default rootRoutes;